/*************************************************/
/* COOKIES                                       */
/*************************************************/

export function cookies() {
    const cookiePlaceholderSelector = '.cookie-placeholder';
    const placeholderSelectors = Array.from(document.querySelectorAll(cookiePlaceholderSelector));

    //Implement this for the specific cookie solution. Check out one of our other websites for an example
    const RenewConsent = categories => {
        Cookiebot.renew();
    }

    const SetPlaceholderDisplayState = (placeholder,displayState) => {
        placeholder.style.display = displayState;
    }

    //Implement this for the specific cookie solution. Check out one of our other websites for an example. In this case, replace the 'false' with Cookie Consent status
    const SetPlaceholderState = () => {
        const marketingPlaceholders = document.querySelectorAll('[data-categories*="marketing"]');
        if (marketingPlaceholders != null) {
            marketingPlaceholders.forEach(placeholder => {
                let displayState = Cookiebot.consent.marketing ? 'none' : 'flex';
                SetPlaceholderDisplayState(placeholder,displayState);
            });
        }

        var statisticsPlaceholders = document.querySelectorAll('[data-categories*="statistics"]');
        if (statisticsPlaceholders != null) {
            statisticsPlaceholders.forEach(placeholder => {
                var displayState = Cookiebot.consent.statistics ? 'none' : 'flex';
                SetPlaceholderDisplayState(placeholder,displayState);
            });
        }

        var preferencesPlaceholders = document.querySelectorAll('[data-categories*="preferences"]');
        if (preferencesPlaceholders != null) {
            preferencesPlaceholders.forEach(placeholder => {
                var displayState = Cookiebot.consent.preferences ? 'none' : 'flex';
                SetPlaceholderDisplayState(placeholder,displayState);
            });
        }
    }

    const init = () => {


        window.addEventListener('CookiebotOnConsentReady', function (e) {
            SetPlaceholderState();
            }, false);

        for(const placeholderSelector of placeholderSelectors) {
            placeholderSelector.addEventListener('click', event => {
                let placeholder = event.target;
                if(!placeholder.classList.contains(cookiePlaceholderSelector)) {
                    placeholder = event.target.closest(cookiePlaceholderSelector);
                }
                event.stopPropagation()
                var categories = placeholder.dataset.categories.split(',');
                RenewConsent(categories);
            });
        }
    };

    init();
}

